import { jsx as _jsx } from "react/jsx-runtime";
import { useRecordContext } from "react-admin";
import { parseISO, format } from "date-fns";
var CustomDateField = function (_a) {
    var base = _a.base, source = _a.source, label = _a.label, emptyText = _a.emptyText;
    var record = useRecordContext();
    if (!record) {
        return _jsx("span", { children: emptyText });
    }
    var dateValue = record[base][source];
    if (!dateValue) {
        return _jsx("span", { children: emptyText });
    }
    try {
        // using date-fns
        return (_jsx("span", { children: format(parseISO(Array.isArray(dateValue) ? dateValue[0] : dateValue), "PP") }));
    }
    catch (_b) {
        return _jsx("span", { children: emptyText });
    }
};
export default CustomDateField;
